<template>
    <div class="row">
        <div class="col-12">
            <div class="p-3 mb-3 float-end">
                <b-button
                    variant="primary"
                    @click="postModalOpen()"
                >
                    {{ $t('modal.nameModalPost') }}
                </b-button>
            </div>
        </div>
        
        <div class="col-12">
            <div class="_table mb-3">
                <b-table
                    :fields="fields"
                    :items="data"
                >
                    <template #cell(numbers)={item}>
            <span
                v-for="(num, index) in item.numbers"
                :key="index"
            >
                {{ num.number | VMask('###(##) ### ## ##') }}
            </span>
                    </template>
                    <template #cell(actions)={item}>
                        <b-button class="me-3"
                                  variant="success"
                                  size="sm"
                                  @click="putModalOpen(item.id)"
                        >
                            <i class="bx bx-pencil fs-4"></i>
                        </b-button>
                        
                        <b-button
                            variant="danger"
                            size="sm"
                            @click="deleteModalOpen(item.id)"
                        >
                            <i class="bx bx-trash fs-4"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        
        <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.pageSize"
            @input="getData"
        ></b-pagination>
        
        <b-modal
            v-model="postModalBool"
            hide-footer
            :title="$t('modal.titlePost')"
        >
            <PostModal
                @onClose="postModalClose"
            />
        </b-modal>
        
        <b-modal
            v-model="putModalBool"
            hide-footer
            :title="$t('modal.titlePut')"
        >
            <PutModal
                @onClose="putModalClose"
                :id="id"
            />
        </b-modal>
        
        <b-modal
            v-model="deleteModalBool"
            hide-footer
            :title="$t('modal.titleDelete')"
        >
            <DeleteModal
                @onClose="deleteModalClose"
                :id="id"
            />
        </b-modal>
    </div>
</template>

<script>
import PostModal from './postModal.vue';
import PutModal from './putModal.vue';
import DeleteModal from './deleteModal.vue';
import {getDealers} from '../../../api/endpoints/dealers'

export default {
    name: "DealersVue",
    components: {
        PostModal,
        PutModal,
        DeleteModal
    },
    data() {
        return {
            id: null,
            postModalBool: false,
            putModalBool: false,
            deleteModalBool: false,
            fields: [
                {key: "id", label: this.$t('table.id.label')},
                {key: "name", label: this.$t('table.name.label')},
                {key: "name_ru", label: this.$t('table.name_ru.label')},
                {key: "address", label: this.$t('table.address.label')},
                {key: "numbers", label: this.$t('table.numbers.label')},
                {key: "actions", label: this.$t('table.actions.label'), class: "d-flex"},
            ],
            total: 1,
            data: [],
            pagination: {
                page: 1,
                pageSize: 15
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        postModalOpen() {
            this.postModalBool = true;
        },
        postModalClose() {
            this.postModalBool = false;
            this.getData();
        },
        putModalOpen(id) {
            this.id = id;
            this.putModalBool = true;
        },
        putModalClose() {
            this.putModalBool = false;
            this.getData();
        },
        deleteModalOpen(id) {
            this.deleteModalBool = true;
            this.id = id;
        },
        deleteModalClose() {
            this.deleteModalBool = false;
            this.getData();
        },
        getData() {
            getDealers(this.pagination).then(res => {
                this.data = res.data.data;
                this.total = res.data.total;
            })
        }
    }
}
</script>
